import { registerComponent, dispatchEvent } from "helpers";

registerComponent(
  "wyatt-delivery-zones",
  class WyattDeliveryZones extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.postalCodeInput = this.querySelector("[data-delivery-zone-input]");
      this.clearButton = this.querySelector("[data-delivery-zone-button]");
      this.messageBox = this.querySelector(
        "[data-delivery-zone-message-success]",
      );
      this.failMessageBox = this.querySelector(
        "[data-delivery-zone-message-fail]",
      );

      const savedPostalCode = localStorage.getItem("can-ship-postal-code");
      if (savedPostalCode) {
        this.postalCodeInput.value = savedPostalCode;
        this.clearButton.classList.remove("hidden");
        this.messageBox.classList.remove("hidden");
        this.failMessageBox.classList.add("hidden");
      }

      if (this.form) {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
      }

      if (this.clearButton) {
        this.clearButton.addEventListener("click", this.handleClear.bind(this));
      }
    }

    handleSubmit(event) {
      event.preventDefault();

      const postalCode = this.postalCodeInput.value.trim().toLowerCase();

      if (!postalCode) return;

      this.handlePostalCodeLookUp(postalCode);
    }

    handlePostalCodeLookUp(postalCode) {
      this.fsaPostalCodes = WYATT.shopify.postal_codes;

      const postalCodePrefix = postalCode.substring(0, 3);
      const matchingPostalCode = this.fsaPostalCodes.find((fsaPostalCode) => {
        const lowerCasePostalCode = fsaPostalCode.FSA.toLowerCase();
        return lowerCasePostalCode.startsWith(postalCodePrefix);
      });

      if (matchingPostalCode) {
        this.handleSuccessfulLookup(postalCode);
        dispatchEvent("deliveryDataChanged");
        dispatchEvent("deliveryDataMyStoreChanged");
      } else {
        this.handleUnsuccessfulLookup();
      }
    }

    handleClear() {
      this.clearForm();

      if (this.clearButton && this.messageBox && this.failMessageBox) {
        this.clearButton.classList.add("hidden");
        this.messageBox.classList.add("hidden");
        this.failMessageBox.classList.add("hidden");
      }

      if (this.postalCodeInput) {
        this.postalCodeInput.classList.remove("text-box--error");
      }
    }

    handleSuccessfulLookup(postalCode) {
      localStorage.setItem("can-ship-postal-code", postalCode);

      if (this.messageBox) {
        this.messageBox.classList.remove("hidden");
        this.failMessageBox.classList.add("hidden");
      }

      if (this.clearButton) {
        this.clearButton.classList.remove("hidden");
      }

      if (this.postalCodeInput) {
        this.postalCodeInput.classList.remove("text-box--error");
      }
    }

    handleUnsuccessfulLookup() {
      this.clearForm();
      if (this.messageBox) {
        this.failMessageBox.classList.remove("hidden");
        this.messageBox.classList.add("hidden");
      }

      if (this.clearButton) {
        this.clearButton.classList.remove("hidden");
      }

      if (this.postalCodeInput) {
        this.postalCodeInput.classList.add("text-box--error");
      }
    }

    clearForm() {
      this.form.reset();
    }
  },
);
